

































import { Component } from 'vue-property-decorator';
import MenuSelectBase from '@/components/menu/menu-select/MenuSelectBase';

@Component
export default class MenuSelectDesktop extends MenuSelectBase {
}
